export enum FrameType {
  Unknown = 'unknown',
  Image = 'image',
  Video = 'video',
  AnimatedGIF = 'animated-gif',
  Text = 'text',
  Captions = 'captions',
  SolidColor = 'solid-color',
  Gradient = 'gradient',
  Pattern = 'pattern',
  LocalFile = 'local-file',
  PhotoLibrary = 'photo-library',
  Shape = 'shape',
  SoundWave = 'sound-wave',
  Sticker = 'sticker'
}



// WEBPACK FOOTER //
// ./src/data/FrameType.ts